// /src/data/projects.js
export const projects = [
    {
      id: 1,
      name: "Townhomes at Sojourn",
      project_link: "https://sojournwinterpark.com",
      location: "Winter Park, Colorado",
      description: "Performed earthmoving and site preparation for multiple multifamily townhome blocks, including excavation, grading, and foundation prep.",
      image: "https://res.cloudinary.com/dtdase4ev/image/upload/v1749739943/thumbnail_dji_fly_20250603_173256_0222_1748993723124_photo_awv3im.jpg"
    },
    {
      id: 2,
      name: "Granby Ranch Residence",
      project_link: "",
      location: "Granby, Colorado",
      description: "Performed earthmoving and site preparation for a single family residence, including excavation, grading, and foundation prep.",
      image: "https://res.cloudinary.com/dtdase4ev/image/upload/v1779047522/5e6a1454-9e96-4657-a104-146a268cb045_ziysh3.jpg"
    },
        {
      id: 3,
      name: "Mt. Olivet Catholic Cemetery",
      project_link: "",
      location: "Arvada, Colorado",
      description: "Performed earthmoving and site preparation for a cemetary mausoleum, including excavation, grading, and foundation prep.",
      image: "https://res.cloudinary.com/dtdase4ev/image/upload/v1781467507/869c3d65-2a62-49bd-b0f5-6b9f51288c5e_drheeg.jpg"
    },
    // Add more projects as needed
  ];
  